


















import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { DxDataGrid, DxColumn, } from 'devextreme-vue/data-grid';

// Servicios
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { toastService } from '@/services/ToastService';
import GenericService from '@/services/GenericService';
import GenericStore from '@/services/GenericStore';

import DialogForm from "@/components/DialogForm.vue";
import DialogConfirm from "@/components/DialogConfirm.vue";
import DialogFullScreen from "@/components/DialogFullScreen.vue";
import GridOData from "@/components/GridOData.vue";

import { Sorteo } from '@/model/Sorteo';
import { DecimoService } from '@/services/DecimoService';
import { Decimo } from '@/model/Decimo';
import { Response } from '@/model/Response';

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    GridOData,
    DialogConfirm,
    DialogForm,
    DialogFullScreen
  },
})
export default class SorteoNumerosTodos extends Vue {

  idGrid: string = "gridNumerosTodos";
  decimoService: any | DecimoService = new DecimoService();

  @Prop({ type: Number, default: 0 })
  idSorteo!: number;

  decimoEliminar: Decimo | any;

  loadDataSource: any | Function;

  columns: any = [
    {
      dataField: "Numero",
      caption: "Número"
    },
    {
      dataField: "Stock",
      caption: "Stock"
    },
    {
      dataField: "Sacado",
      caption: "Sacado"
    },
    {
      dataField: "FechaExtraccion",
      caption: "Fecha de extracción",
      dataType: "date",
      format: "dd/MM/yyyy"
    },
    {
      dataField: "MetodoExtraccion",
      caption: "Método de extracción",
      loadAll: true
    }
  ];

  editing: any = {
    mode: "cell",
    allowAdding: false,
    allowUpdating: false,
    allowDeleting: false
  };

  width: string = "100%";
  height: number = 500;
  headerFilter: any = { visible: true };

  nameEventRefresh: string = "GridTodos-Refresh"

  created(){
    this.loadDataSource = async (queryString: string) =>{
      if(queryString !== undefined){
        return await this.decimoService.bySorteo(this.idSorteo, queryString);
      }else{
        return
      }
    }
  }

  refresh(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoNumerosTodos.vue - refresh()");
    eventService.emit(this.nameEventRefresh, true);
  }

  destroyed(){
    
  }
}
